import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { sectionAnchors } from '../config/routes'

const NAV_ITEMS = [
  { href: sectionAnchors.features, label: 'Features' },
  { href: sectionAnchors.howItWorks, label: 'How it works' },
  { href: sectionAnchors.whatItReads, label: 'What it reads' },
  { href: sectionAnchors.pricing, label: 'Pricing' },
  { href: sectionAnchors.faq, label: 'FAQ' },
  { href: '/help', label: 'Help' },
]

const FOOTER_PRODUCT_LINKS = [
  { href: sectionAnchors.features, label: 'Features' },
  { href: sectionAnchors.howItWorks, label: 'How it works' },
  { href: sectionAnchors.pricing, label: 'Pricing' },
  { href: sectionAnchors.faq, label: 'FAQ' },
]

const FOOTER_APP_LINKS = [
  { href: sectionAnchors.contact, label: 'App Store' },
  { href: sectionAnchors.contact, label: 'Google Play' },
]

// The single master logo (sage square + white scan-frame + checkmark) — the exact
// same SVG used for the app icon / splash / favicon, so web and app are one logo.
// The `.mark` is just a rounded, rotated, shadowed frame; the SVG fills it.
const LogoMark = () => (
  <span className="mark" aria-hidden="true">
    <img src="/assets/img/quickscore-logo.svg" alt="" width={34} height={34} />
  </span>
)

// Sticky Chalk & Paper nav (wordmark + anchor items + signup/app CTAs, mobile
// hamburger) and footer, ported from the prototype's header.nav/footer markup +
// inline mobile-menu JS (docs/quickscore/spec/…prototype.html:619-629).
export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => setMenuOpen(false)

  return (
    <div>
      <header className="nav" id="top">
        <div className="wrap nav-inner">
          <a className="brand" href="#top">
            <LogoMark />
            QuickScore
          </a>
          <nav className={`links${menuOpen ? ' open' : ''}`} id="navlinks">
            {NAV_ITEMS.map((item) => (
              <a key={item.href} href={item.href} onClick={closeMenu}>
                {item.label}
              </a>
            ))}
          </nav>
          <div className="nav-cta">
            <a className="btn btn-ghost" href={sectionAnchors.contact}>
              Get started
            </a>
            <a className="btn btn-primary" href="#get">
              Get the app
            </a>
            <button
              className="menu-btn"
              id="menuBtn"
              aria-label="Menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      <Outlet />

      <footer>
        <div className="wrap">
          <div className="foot-grid">
            <div className="foot-brand-copy">
              <a className="brand" href="#top">
                <LogoMark />
                QuickScore
              </a>
              <p className="foot-tagline">
                AI-powered answer sheet grading. Turn a stack of paper tests into scored results in minutes.
              </p>
            </div>
            <div className="cols">
              <div>
                <h5>Product</h5>
                {FOOTER_PRODUCT_LINKS.map((item) => (
                  <a key={item.label} href={item.href}>
                    {item.label}
                  </a>
                ))}
              </div>
              <div>
                <h5>Get the app</h5>
                {FOOTER_APP_LINKS.map((item) => (
                  <a key={item.label} href={item.href}>
                    {item.label}
                  </a>
                ))}
              </div>
              <div>
                <h5>Company</h5>
                <a href={sectionAnchors.contact}>Contact</a>
                <a href="/privacy">Privacy</a>
                <a href="/terms">Terms</a>
                <a href="/help">Help</a>
              </div>
            </div>
          </div>
          <div className="foot-bottom">
            <span>© 2026 QuickScore. All rights reserved.</span>
            <span>Made for teachers.</span>
          </div>
        </div>
      </footer>
    </div>
  )
}
